export default {
  'component_tracking_day_label': '关键日',
  'component_tracking_day_key_days': '关键',
  'component_tracking_day_customize': '自定义',
  'component_tracking_day_error': '您的输入不恰当。<br /> 请重新输入[1,{maximumDays}]区间的追踪天数。',
  'component_tracking_day_placeholder': '请输入追踪天数，例如：7。',
  'component_tracking_day_confirm': '确认',
  'component_tracking_day_back': '返回',
}